export enum AlertsActions {
    SET_ERROR_ALERT = "setErrorAlert",
    SET_SUCCES_ALERT = "setSuccesAlert",
    SET_DIALOG_ERROR = "setDialoError",
    CLEAR_ALERTS = "clearAlerts",
    SET_LIST_MESSAGE = "setListMessage",
    SET_LIST_ERR = "setListErr",
    CLEAR_LIST_MESSAGES = "clearLsitMessages"
}